export const getSummaryData = (data?: Record<string, unknown>[], props?: Record<string, unknown>): Record<string, unknown> => {
    
  if (!data) return undefined

  const {
    totals_key,
    count_key,
    color_key,
    colors
  } = props || {}

  const new_item = {
    total: 0,
    average: 0,
    count: 0,
    high: Number.NEGATIVE_INFINITY,
    low: Number.POSITIVE_INFINITY,
    items: [] as Record<string, unknown>[],
    color: undefined as string | undefined, 
    indexes: [] as number[],
  }

  const summary_data = {...new_item}  as typeof new_item

  for (let i = 0; i < data?.length; i++) {
    let d = data?.[i]
    const count = count_key ? Number(d?.[count_key] || 0) : 1
    d = {...d, index: i }
      
    summary_data.count += count
    summary_data.items.push(d)
    summary_data.indexes.push(i)

    if (totals_key) {
      const val = Number(d?.[totals_key] || 0)
      summary_data.total += val
      summary_data.average = summary_data.total / summary_data.count
      if (val > summary_data.high) summary_data.high = val
      if (val < summary_data.low) summary_data.low = val
    }

    
    if (color_key && colors) {
      const color_val = d?.[color_key] as string
      summary_data.color = colors?.[color_val] || summary_data?.color
    }
    
  }
  
  return summary_data

}


export const getGroupedSummaryData = (data?: Record<string, unknown>[], props?: Record<string, unknown>): Record<string, unknown>[] => {
   
  const summary_totals = { }
  const flat_data = []

  const {  grouping_key, totals_key, flatten = true, value_keys } = props || {}
  const grouping_keys = props?.grouping_keys || Array.isArray(grouping_key) ? grouping_key : grouping_key ? [grouping_key] : undefined
  const grouped_data = {} as Record<string, typeof data[]>
 
  if (grouping_keys || grouping_key || value_keys) {
  
    // group data by value of grouping key(s) by using object.groupBy or similar, then get summary data for each group
    for (let i = 0; i < data?.length; i++) {

      let item = data?.[i]
      let group_id = undefined

      if (grouping_keys) {
        group_id = grouping_keys.map((k) => item?.[k]).join('__')
      } else {
        group_id = item?.[grouping_key as string] 
      }
      
 
      if (value_keys) {
        
        value_keys.forEach((k) => {
          let item = data?.[i]
          const group_id = k
          item = {...item, grouping_key: k, group: group_id, index: i }
          if (!grouped_data?.[group_id]) grouped_data[group_id] = []
          grouped_data[group_id].push(item)
        })
      } else { 
        item = {...item, group: group_id, index: i }
        if (!grouped_data?.[group_id]) grouped_data[group_id] = []
        grouped_data[group_id].push(item) 
      }
    }
 
  }


  Object.entries(grouped_data).forEach(([group_id, items]) => {
    const group_summary = getSummaryData(
      items as Record<string, unknown>[], 
      {
        ...props,
        totals_key,
        grouping_key: 'group'
      }
    )
    let new_item = {...group_summary }
    const groups = group_id?.split?.('__') || []
    grouping_keys?.forEach((k, index) => {
      new_item = {...new_item, [k]: groups?.[index] }
    }) 
     
    summary_totals[group_id] = new_item
   
      if (flatten) flat_data.push(new_item)
    })

 
  return flatten ? flat_data : summary_totals
}
 